import React from 'react';
import classnames from 'classnames';
import edgeArrowBlack from '../../../../../../common/assets/pagination-arrow-to-edge-black.svg';
import gotoArrowBlack from '../../../../../../common/assets/pagination-arrow-black.svg';
import edgeArrowGray from '../../../../../../common/assets/pagination-arrow-to-edge-gray.svg';
import gotoArrowGray from '../../../../../../common/assets/pagination-arrow-gray.svg';
import sortArrow from '../../../../../../common/assets/arrow-select-black.svg';
import DropdownSelectColumn from '../../../../../../common/components/DropdownSelectColumns';
import {sortingDirection} from '../../../../../../common/constants/sorting';
import styles from './styles.module.scss';

const pageSize = 15;

const ArrowDirection = ({direction}) => {
  return (
    <img
      src={sortArrow}
      alt="sort-asc"
      className={classnames(styles.sortDirection, {
        [styles.descending]: direction === sortingDirection.DESCENDING
      })}
    />
  );
};

const DataTableView = ({
                         getTableProps,
                         getTableBodyProps,
                         headerGroups,
                         prepareRow,
                         page,
                         canPreviousPage,
                         canNextPage,
                         pageCount,
                         gotoPage,
                         nextPage,
                         previousPage,
                         totalResultCount,
                         customClassNames = {},
                         showPagination,
                         allColumns,
                         pageIndex,
                         columnStorageKey,
                         onColumnChange,
                         allowSorting,
                         onSortChange,
                         sortColumnName,
                         sortDirection,
                       }) => {
  const currentRange = `${(pageIndex) * pageSize + 1} - ${Math.min((pageIndex) * pageSize + pageSize, totalResultCount)}`;
  const mapHeader = () => {
    return headerGroups.map((headerGroup, ind) => (
      <tr
        {...headerGroup.getHeaderGroupProps()}
        className={classnames(styles.row, customClassNames.row)}
        key={ind}
      >
        {headerGroup.headers.map((column, ind) => (
            <th
              {...column.getHeaderProps()}
              className={classnames(
                styles.headerCell,
                customClassNames.headerCell,
                {[styles.sortableHeader]: allowSorting}
              )}
              key={ind}
              onClick={() => {
                if (allowSorting) {
                  const direction =
                    sortColumnName === column.id &&
                    sortDirection === sortingDirection.ASCENDING
                      ? sortingDirection.DESCENDING
                      : sortingDirection.ASCENDING;
                  onSortChange(column.id, direction);
                }
              }}
            >
              {Array.isArray(column.Header)
                ? column.Header.map(item => <div>{item}</div>)
                : column.render('Header')
              }
              {allowSorting && (column.id === sortColumnName) && (
                <img
                  src={sortArrow}
                  className={classnames(styles.sortDirection, {
                    [styles.descending]: sortDirection === sortingDirection.DESCENDING,
                    [styles.hidden]: column.id !== sortColumnName,
                  })}
                  alt="i"
                />
              )}
            </th>
          ))}
      </tr>
    ));
  };

  const mapRows = () => {
    return page.map((row, ind) => {
      prepareRow(row);

      return (
        <tr
          {...row.getRowProps()}
          key={ind}
          className={`${styles.row} ${customClassNames.row || ''}`}
        >
          {mapCells(row)}
        </tr>
      );
    });
  };

  const mapCells = (row) => {
    return row.cells.map((cell, ind) => {
      return (
        <td
          {...cell.getCellProps()}
          className={`${styles.cell} ${customClassNames.cell || ''}`}
          key={ind}
        >
          {cell.render('Cell')}
        </td>
      );
    });
  };

  return (
    <>
      {columnStorageKey && (
        <div className={styles.toolsContainer}>
          <DropdownSelectColumn
            id={columnStorageKey}
            allColumns={allColumns}
            onColumnChange={onColumnChange}
          />
        </div>
      )}
      <div
        className={`${styles.formContainer} ${customClassNames.formContainer || ''}`}>
        <table {...getTableProps()}
               className={`${styles.form} ${customClassNames.form || ''}`}>
          <thead className={`${styles.thead} ${customClassNames.thead || ''}`}>
          {mapHeader()}
          </thead>
          <tbody {...getTableBodyProps()}
                 className={`${customClassNames.tbody}`}>
          {mapRows()}
          </tbody>
        </table>
      </div>
      {(showPagination && totalResultCount) ? (
        <div
          className={`${styles.pagination} ${customClassNames.pagination || ''}`}>
          <div className={`${styles.pageInfoLabel} ${styles.range}`}>
            {currentRange}
            <span>מתוך</span>
            {totalResultCount}
          </div>
          <button
            type="button"
            onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}
            className={`${styles.arrow} ${styles.start}`}
          >
            <img
              src={(canNextPage) ? edgeArrowBlack : edgeArrowGray}
              className={(canNextPage) ? styles.reverse : ''}
              alt="go to end"
            />
          </button>
          <button
            type="button"
            onClick={() => nextPage()} disabled={!canNextPage}
            className={styles.arrow}
          >
            <img
              src={(canNextPage) ? gotoArrowBlack : gotoArrowGray}
              className={(canNextPage) ? styles.reverse : ''}
              alt="next page"
            />
          </button>
          <div className={`${styles.pageInfoLabel} ${styles.current}`}>
            <span>עמוד</span>
            {pageIndex + 1}
          </div>
          <button
            type="button"
            onClick={() => previousPage()}
            disabled={!canPreviousPage || (pageIndex === 0)}
            className={`${styles.arrow}`}
          >
            <img
              src={(canPreviousPage && (pageIndex !== 0)) ? gotoArrowBlack : gotoArrowGray}
              className={(canPreviousPage && (pageIndex !== 0)) ? '' : styles.reverse}
              alt="previous page"
            />
          </button>
          <button
            type="button"
            onClick={() => gotoPage(0)} disabled={!canPreviousPage}
            className={`${styles.arrow} ${styles.end}`}
          >
            <img
              src={(canPreviousPage) ? edgeArrowBlack : edgeArrowGray}
              className={(canPreviousPage) ? '' : styles.reverse}
              alt="go to start"
            />
          </button>
        </div>
      ) : null}
    </>
  );
};

export default DataTableView;